import React from 'react';
import { InputAdornment, TextField } from '@mui/material';

import { exchangeRates } from 'src/utils/const';
import { formatCurrency } from 'src/utils/functions';

const InputTextField = ({
  field,
  stateObj,
  handleValueChange,
  currency,
  disabled,
  hideLabel,
}: {
  field: {
    key: string;
    unit: string;
    label: string;
    tooltip?: string;
  };
  stateObj: any;
  handleValueChange: (key: string, event: any) => void;
  currency: string;
  disabled?: boolean;
  hideLabel?: boolean;
}) => {
  const handleOnInputChange = (event: any) => {
    const rawValue = event.target.value;
    let parsedValue = parseFloat(rawValue.replace(/[^0-9.]/g, ''));
    if (field.unit === 'years') {
      // Restrict between 0 and 100
      parsedValue = Math.min(100, Math.max(0, parsedValue || 0));
    } else if (field.unit === 'days') {
      // Restrict between 0 and 365
      parsedValue = Math.min(365, Math.max(0, parsedValue || 0));
    }
    handleValueChange(field.key, parsedValue || 0);
  };

  return (
    <TextField
      id={field.label}
      label={field.label}
      variant="outlined"
      size="small"
      fullWidth
      defaultValue={stateObj[field.key]}
      value={
        stateObj[field.key] === '' ||
        stateObj[field.key] === undefined ||
        stateObj[field.key] === null
          ? ''
          : field.unit === '%'
          ? stateObj[field.key].toString()
          : formatCurrency(stateObj[field.key].toString())
      }
      onChange={handleOnInputChange}
      type={field.unit === '%' ? 'number' : 'tel'}
      error={!disabled && !stateObj[field.key]}
      disabled={disabled}
      InputProps={
        field.unit === '$'
          ? {
              startAdornment: (
                <InputAdornment position="start">{exchangeRates[currency].symbol}</InputAdornment>
              ),
              notched: !hideLabel,
            }
          : {
              endAdornment: <InputAdornment position="end">{field.unit}</InputAdornment>,
              notched: !hideLabel,
            }
      }
      helperText={field.tooltip || undefined}
      FormHelperTextProps={field.tooltip ? { sx: { fontSize: '11px', lineHeight: 1.35, mt: 0.5 } } : undefined}
      InputLabelProps={{
        shrink: !hideLabel,
      }}
      sx={{
        '.MuiInputLabel-root': {
          display: hideLabel ? 'none' : 'block',
        },
      }}
    />
  );
};

export default InputTextField;
